import { commonTypes } from '../common';

export const types = {

};

export const initialState = {
  ppipAvailable: false,
};

const UINeedsPpipReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_PPIP_AS_AVAILABLE: {
      const newState = {
        ...state,
        ppipAvailable: true,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  
};

export default UINeedsPpipReducer;
